import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

export type Icons = 'ui-1_check' | 'ui-1_simple-remove' | 'travel_info' | 'ui-1_bell-53';
export type Type = 'success' | 'danger' | 'info' | 'warning';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  /**
   * @constructor
   * @param {ToastrService} _toast 
   * @param {TranslateService} _translate 
   */
  constructor(
    private _toast: ToastrService,
    private _translate: TranslateService
  ) { }

  /**
   * Muestra las notificaciones con su mensaje correspondiente
   * @param {string} message_code - Código del mensaje en la hoja de idiomas
   * @param {string} type - Tipo de mensaje a mostrar (success, danger, info, warning, etc.)
   * @param {string} icon - icono que tendrá la notificación
   * @returns {Promise<void>}
   */
  public async showNotification(message_code: string, type: Type, icon: Icons, values?: any): Promise<void> {
    const Message: string = await this._translate.get(message_code, values).toPromise();
    this._toast.show(`<span class="now-ui-icons ${icon}"></span>`, Message, {
      timeOut: 4000,
      closeButton: true,
      enableHtml: true,
      toastClass: `alert alert-${type} alert-with-icon`
    })
  }
}